import React, { useState, useEffect, useContext, useRef } from "react";
import { useFetchApi } from "../../hooks/useFetchApi";
import EPSCurrenctVsPast from "../../components/Graphs/EPSCurrentVsPast";
import EPSGrowthCurrenctVsPast from "../../components/Graphs/EPSGrowthCurrentVsPast";
import RevGrossNet from "../../components/Graphs/RevGrossNet";
import GrossNetMargin from "../../components/Graphs/GrossNetMargin";
import RevenueCurrenctVsPast from "../../components/Graphs/RevenueCurrentVsPast";
import RevenueGrowthCurrenctVsPast from "../../components/Graphs/RevenueGrowthCurrentVsPast";
import GrossNetPastAndPresent from "../../components/Graphs/GrossNetPastAndPresent";
import GrossNetProfitGrowth from "../../components/Graphs/GrossNetProfitGrowth";
import EPSQtrOnQtr from "../../components/Graphs/EPSQtrOnQtr";
import RevenueQtrOnQtr from "../../components/Graphs/RevenueQtrOnQtr";
import GrossProfitQtrOnQtr from "../../components/Graphs/GrossProfitQtrOnQtr";
import NetProfitQtrOnQtr from "../../components/Graphs/NetProfitQtrOnQtr";
import EPSGrowthQtrOnQtrTrendLine from "../../components/Graphs/EPSGrowthQtrOnQtrTrendLine";
import GrossProfitGrowthQtrOnQtrTrendLine from "../../components/Graphs/GrossProfitGrowthQtrOnQtrTrendLine";
import NetProfitGrowthQtrOnQtrTrendLine from "../../components/Graphs/NetProfitGrowthQtrOnQtrTrendLine";
import RevenueGrowthQtrOnQtrTrendLine from "../../components/Graphs/RevenueGrowthQtrOnQtrTrendLine";
import { Tabs } from "antd";
import { isAllowed } from "../../components/Entitlements";
import { Tab } from "../../components/Tab";
import DynamicTab from "./DynamicTab";
import { StateContext } from "../../store/context";

import { KEYS } from "../../setup/entitlements";
import CompanyProfiles from "./CompanyProfiles";
import TTMRevenue from "../../components/Graphs/TTMRevenue";
import { TitleArea } from "../../components/Typography/titleArea";

import { MoreOptions } from "./_components/moreOptions";
import { StockComparisonTable } from "./_components/stockDetailsCard";
import { ComparativeInsights } from "./_components/comparativeInsights";
import { PrimaryInsights } from "./_components/primaryInsight";

import { useNavigate } from "react-router-dom";
import { StockSelector } from "./_components/stockSelector";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { usePreventCopy } from "../../hooks/usePreventCopy";
import { STOCK_EXCHANGES } from "../../helper";
import DisclaimerButton from "../../components/DisclaimerButton";
import "../../styles/theme-tokens.css";
import "../../styles/glass-tokens.css";
import "./compare.theme.css";

const FUNDAMENTAL_STORAGE_KEY = "fundamental_analysis_selection";

const CompareDashboard: React.FC = (): React.ReactElement => {
  usePreventCopy();
  const {
    baseCurrency,
    authUser: { allowed, sub_plan, role_name, username },
  } = useContext(StateContext);

  const navigate = useNavigate();

  const defaultsInitialized = useRef(false);

  const isPremiumUser =
    sub_plan === "Premium Plan" && role_name === "Premium Customer"
      ? true
      : false;
  const isBasicCustomer =
    sub_plan === "Free Plan" && role_name === "Basic Customer";

  const [primaryStock, setPrimaryStock] = useState<any>();
  const [primaryCurrency, setPrimaryCurrency] = useState<string>("LKR");
  const [stocksToCompare, setStocksToCompare] = useState<Array<any>>([]);
  const [stocks, setStocks] = useState<any>({});
  const [compareResults, setCompareResult] = useState<any>({});
  const [compareOtherStockResults, setOtherStockResults] = useState<any>([]);
  const [peEstimate, setPeEstimate] = useState<string>("");
  const [expectedGrowth, setExpectedGrowth] = useState<string>("");
  const [adverts, setAds] = useState<any>();
  const [t, setT] = useState<Array<Tab>>([]);
  const [partialData, setPartialData] = useState<boolean>(false);
  const [selectedStock, setSelectedStock] = useState<any>([]);
  const [selectedSecondaryStocks, setSelectedSecondaryStocks] = useState<any>(
    [],
  );
  const [grapCategories, setGraphCategories] = useState();
  const [tabStockComapre, setTabStockComapre] = useState<any>([]);
  const [scrollDirection, setScrollDirection] = useState<"left" | "right">(
    "left",
  );
  const [peEstimatea, setPeEstimates] = useState<string | undefined>("");
  const [epsGrowth, setEpsGrowth] = useState<string | undefined>("");
  const [primaryStocks, setPrimaryStocks] = useState<any>(null);
  const [secondaryStocks, setSecondaryStocks] = useState<any>([]);
  const [scrollUpdate, setScrollUpdate] = useState<boolean>(false);
  const [mobileScrollIndex, setMobileScrollIndex] = useState<number>(0);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  // Right-hand ad column — visible by default (matches the reserved
  // lg:w-3/12 space non-premium users always had), collapsible via the
  // arrow button so the main content can reclaim that width on demand.
  const [showAdPanel, setShowAdPanel] = useState<boolean>(true);

  const [isDark, setIsDark] = useState<boolean>(() => {
    return localStorage.getItem("darkMode") === "true";
  });
  const {
    response,
    loading: stockLoading,
    execute: getStocks,
  } = useFetchApi("/api/all-stocks", {}, "GET");
  const {
    response: compareData,
    loading: compareLoading,
    execute: compareStocks,
  } = useFetchApi("/api/compare");
  const {
    response: comparedStocksData,
    loading: comparedStockLoading,
    execute: getComparedStocks,
  } = useFetchApi("/api/stocks-to-compare");

  const {
    response: ads,
    loading: adsLoading,
    execute: getAds,
  } = useFetchApi("/api/ads", {}, "GET");

  const {
    response: graphCategories,
    loading: graphCategoriesLoading,
    execute: getGraphCategories,
  } = useFetchApi("/api/graph-categories", {}, "GET");

  useEffect(() => {
    console.log("rendering" + Math.random());
    getStocks();
    getAds();
    getGraphCategories();
  }, []);

  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (response && Object.keys(response).length) {
      setStocks(response);

      if (
        !defaultsInitialized.current &&
        !primaryStocks &&
        secondaryStocks.length === 0
      ) {
        const allStocks = STOCK_EXCHANGES.flatMap(
          (exchange) =>
            (response &&
              response.find(
                (section: { section: string }) => section?.section === exchange,
              )?.options) ||
            [],
        ).filter((stock) => stock.status === 1);

        let primary: any = null;
        let secondary: any[] = [];
        let userExplicitlyCleared = false;

        try {
          const saved = localStorage.getItem(FUNDAMENTAL_STORAGE_KEY);
          if (saved) {
            const parsed = JSON.parse(saved);

            if (parsed?.cleared) {
              // User deliberately cleared their selection last time — respect it
              userExplicitlyCleared = true;
            } else {
              primary =
                allStocks.find((s) => s.id === parsed.primaryId) || null;
              secondary = allStocks.filter((s) =>
                (parsed.secondaryIds || []).includes(s.id),
              );
            }
          }
        } catch {
          // ignore parse errors, fall through to hardcoded defaults
        }

        if (userExplicitlyCleared) {
          // Don't apply any default — leave everything empty, but mark as initialized
          // so this effect doesn't try again on subsequent response updates
          defaultsInitialized.current = true;
          return;
        }

        // Fall back to hardcoded defaults if nothing saved/found
        if (!primary) {
          const defaultPrimary = allStocks.find(
            (stock) => stock.ticker_symbol === "ACL.N",
          );
          const defaultSecondary = allStocks.filter((stock) =>
            ["TILE.N"].includes(stock.ticker_symbol),
          );

          primary = defaultPrimary || allStocks[0];
          secondary =
            defaultSecondary.length > 0
              ? defaultSecondary
              : allStocks.slice(1, 2);
        }

        if (primary) {
          setPrimaryStocks(primary);
          setSecondaryStocks(secondary);
          defaultsInitialized.current = true;
          handleGenerate(
            primary,
            secondary,
            peEstimatea || "",
            epsGrowth || "",
          );
        }
      }
    }
  }, [response]);

  // Persist the user's selection whenever it changes
  useEffect(() => {
    if (primaryStocks) {
      localStorage.setItem(
        FUNDAMENTAL_STORAGE_KEY,
        JSON.stringify({
          primaryId: primaryStocks.id,
          secondaryIds: secondaryStocks.map((s: any) => s.id),
        }),
      );
    }
  }, [primaryStocks, secondaryStocks]);

  useEffect(() => {
    if (ads && !adsLoading) {
      setAds(ads);
    }
  }, [ads, adsLoading]);

  const handleGenerate = (
    primaryStock: any,
    stocksToCompare: any,
    peEstimate: string,
    expectedGrowth: string,
  ) => {
    setCompareResult({});
    setOtherStockResults([]);
    setT([]);
    setPrimaryStock(primaryStock);
    setStocksToCompare(stocksToCompare);

    setPeEstimate(peEstimate);
    setExpectedGrowth(expectedGrowth);

    compareStocks({
      id: primaryStock?.id,
      peEstimate,
      expectedGrowth,
      baseCurrency,
    });
    if (stocksToCompare.length) {
      getComparedStocks({
        stocks: stocksToCompare,
        primaryStock,
        peEstimate,
        expectedGrowth,
        baseCurrency,
      });
    }
  };

  useEffect(() => {
    if (stocksToCompare && stocksToCompare.length) {
      if (
        !comparedStockLoading &&
        comparedStocksData &&
        Object.keys(comparedStocksData).length &&
        !compareLoading &&
        compareData &&
        Object.keys(compareData).length
      ) {
        // Always set compareResult so Parameters (dynamic) section populates.
        // partialData=true only hides charts that need 8+ quarters (EPS comparison).
        const hasEpsError =
          compareData.epsPastAndPresentQuarter &&
          compareData.epsPastAndPresentQuarter.status === "error";
        const hasComparedError = comparedStocksData.status === "error";
        setPartialData(!!(hasEpsError || hasComparedError));
        setCompareResult(compareData);
        if (!hasComparedError) {
          setOtherStockResults(comparedStocksData);
        }
      }
    } else {
      if (!compareLoading && compareData && Object.keys(compareData).length) {
        const hasEpsError =
          compareData.epsPastAndPresentQuarter &&
          compareData.epsPastAndPresentQuarter.status === "error";
        setPartialData(!!hasEpsError);
        setCompareResult(compareData);
      }
    }
  }, [
    compareData,
    compareLoading,
    stocksToCompare,
    comparedStocksData,
    comparedStockLoading,
  ]);

  // to trigger when base currency changes
  useEffect(() => {
    if (primaryStock && Object.keys(primaryStock).length) {
      setCompareResult((prev: any) => {});
      setStocksToCompare((prev: any) => []);
      setT([]);
      setTimeout(() => {
        handleGenerate(
          primaryStock,
          stocksToCompare,
          peEstimate,
          expectedGrowth,
        );
      }, 100);
    }
  }, [baseCurrency]);

  const EPSCurrenctVsPastGraph = ({ compareResults }: any) => (
    <div>
      <div className={`flex w-full  `}>
        {compareResults &&
        Object.keys(compareResults).length &&
        compareResults.epsPastAndPresentQuarter &&
        !compareResults.epsPastAndPresentQuarter.status &&
        Object.keys(compareResults.epsPastAndPresentQuarter).length ? (
          <EPSCurrenctVsPast data={compareResults.epsPastAndPresentQuarter} />
        ) : null}
      </div>
    </div>
  );

  const EPSGrowthCurrenctVsPastGraph = ({ compareResults }: any) => (
    <div>
      <div className={`flex w-full`}>
        {compareResults &&
        Object.keys(compareResults).length &&
        compareResults.epsGrowthCurrentVsPast &&
        Object.keys(compareResults.epsGrowthCurrentVsPast).length ? (
          <EPSGrowthCurrenctVsPast
            data={compareResults.epsGrowthCurrentVsPast}
          />
        ) : null}
      </div>
    </div>
  );

  const RevGrossNetGraph = ({ compareResults }: any) => (
    <div className="flex w-full ">
      {compareResults &&
      Object.keys(compareResults).length &&
      compareResults.grossNetRev &&
      Object.keys(compareResults.grossNetRev).length ? (
        <RevGrossNet data={compareResults.grossNetRev} />
      ) : null}
    </div>
  );

  const GrossNetMarginGraph = ({ compareResults }: any) => (
    <div className="flex w-full ">
      {compareResults &&
      Object.keys(compareResults).length &&
      compareResults.grossNetMargin &&
      Object.keys(compareResults.grossNetMargin).length ? (
        <GrossNetMargin data={compareResults.grossNetMargin} />
      ) : null}
    </div>
  );

  const RevenueCurrenctVsPastGraph = ({ compareResults }: any) => (
    <div>
      <div className={`flex w-full`}>
        {compareResults &&
        Object.keys(compareResults).length &&
        compareResults.revPastAndPresentQuarter &&
        Object.keys(compareResults.revPastAndPresentQuarter).length ? (
          <RevenueCurrenctVsPast
            data={compareResults.revPastAndPresentQuarter}
          />
        ) : null}
      </div>
    </div>
  );

  const RevenueGrowthCurrenctVsPastGraph = ({ compareResults }: any) => (
    <div>
      <div className={`flex w-full`}>
        {compareResults &&
        Object.keys(compareResults).length &&
        compareResults.revenueGrowthCurrentVsPast &&
        Object.keys(compareResults.revenueGrowthCurrentVsPast).length ? (
          <RevenueGrowthCurrenctVsPast
            data={compareResults.revenueGrowthCurrentVsPast}
          />
        ) : null}
      </div>
    </div>
  );

  const GrossNetProfitGrowthGraph = ({ compareResults }: any) => (
    <div className="flex w-full ">
      {compareResults &&
      Object.keys(compareResults).length &&
      compareResults.grossNetGrowth &&
      Object.keys(compareResults.grossNetGrowth).length ? (
        <GrossNetProfitGrowth data={compareResults.grossNetGrowth} />
      ) : null}
    </div>
  );

  const GrossNetPastAndPresentGraph = ({ compareResults }: any) => (
    <div className="flex w-full ">
      {compareResults &&
      Object.keys(compareResults).length &&
      compareResults.grossNetPastPresent &&
      Object.keys(compareResults.grossNetPastPresent).length ? (
        <GrossNetPastAndPresent data={compareResults.grossNetPastPresent} />
      ) : null}
    </div>
  );

  const EPSQtrOnQtrGraph = ({ compareResults }: any) => (
    <div>
      <div className={`flex w-full`}>
        {compareResults &&
        Object.keys(compareResults).length &&
        compareResults.epsQtrOnQtr &&
        Object.keys(compareResults.epsQtrOnQtr).length ? (
          <EPSQtrOnQtr data={compareResults.epsQtrOnQtr} />
        ) : null}
      </div>
    </div>
  );

  const EPSGrowthQtrOnQtrTrendLineGraph = ({ compareResults }: any) => (
    <div className="flex w-full ">
      {compareResults &&
      Object.keys(compareResults).length &&
      compareResults.epsGrowthQtrOnQtrTrendLine &&
      Object.keys(compareResults.epsGrowthQtrOnQtrTrendLine).length ? (
        <EPSGrowthQtrOnQtrTrendLine
          data={compareResults.epsGrowthQtrOnQtrTrendLine}
        />
      ) : null}
    </div>
  );

  const RevenueQtrOnQtrGraph = ({ compareResults }: any) => (
    <div>
      <div className={`flex w-full`}>
        {compareResults &&
        Object.keys(compareResults).length &&
        compareResults.revQtrOnQtr &&
        Object.keys(compareResults.revQtrOnQtr).length ? (
          <RevenueQtrOnQtr data={compareResults.revQtrOnQtr} />
        ) : null}
      </div>
    </div>
  );

  const RevenueGrowthQtrOnQtrTrendLineGraph = ({ compareResults }: any) => (
    <div className="flex w-full ">
      {compareResults &&
      Object.keys(compareResults).length &&
      compareResults.revQtrOnQtrTrend &&
      Object.keys(compareResults.revQtrOnQtrTrend).length ? (
        <RevenueGrowthQtrOnQtrTrendLine
          data={compareResults.revQtrOnQtrTrend}
        />
      ) : null}
    </div>
  );

  const GrossProfitQtrOnQtrGraph = ({ compareResults }: any) => (
    <div className="flex w-full ">
      {compareResults &&
      Object.keys(compareResults).length &&
      compareResults.grossProfitQtrOnQtr &&
      Object.keys(compareResults.grossProfitQtrOnQtr).length ? (
        <GrossProfitQtrOnQtr data={compareResults.grossProfitQtrOnQtr} />
      ) : null}
    </div>
  );

  const GrossProfitGrowthQtrOnQtrTrendLineGraph = ({ compareResults }: any) => (
    <div className="flex w-full ">
      {compareResults &&
      Object.keys(compareResults).length &&
      compareResults.grossProfitQtrOnQtrTrend &&
      Object.keys(compareResults.grossProfitQtrOnQtrTrend).length ? (
        <GrossProfitGrowthQtrOnQtrTrendLine
          data={compareResults.grossProfitQtrOnQtrTrend}
        />
      ) : null}
    </div>
  );

  const NetProfitQtrOnQtrGraph = ({ compareResults }: any) => (
    <div className="flex w-full ">
      {compareResults &&
      Object.keys(compareResults).length &&
      compareResults.netProfitQtrOnQtr &&
      Object.keys(compareResults.netProfitQtrOnQtr).length ? (
        <NetProfitQtrOnQtr data={compareResults.netProfitQtrOnQtr} />
      ) : null}
    </div>
  );

  const NetProfitGrowthQtrOnQtrTrendLineGraph = ({ compareResults }: any) => (
    <div>
      <div className={`flex w-full`}>
        {compareResults &&
        Object.keys(compareResults).length &&
        compareResults.netProfitQtrOnQtrTrend &&
        Object.keys(compareResults.netProfitQtrOnQtrTrend).length ? (
          <NetProfitGrowthQtrOnQtrTrendLine
            data={compareResults.netProfitQtrOnQtrTrend}
          />
        ) : null}
      </div>
    </div>
  );

  const TTMRevenueGraph = ({ compareOtherStockResults }: any) => (
    <div className="flex w-full ">
      {compareOtherStockResults &&
      Object.keys(compareOtherStockResults).length &&
      Object.keys(compareOtherStockResults.graphs).length ? (
        <TTMRevenue data={compareOtherStockResults.graphs.TTMRevenue} />
      ) : null}
    </div>
  );

  // static graphs if any
  const staticGraphs: any = {
    "EPS Current Vs Past": EPSCurrenctVsPastGraph,
    "EPS Growth Current Vs Past": EPSGrowthCurrenctVsPastGraph,
    "Revenue Current Vs Past": RevenueCurrenctVsPastGraph,
    "Revenue Growth Current Vs Past": RevenueGrowthCurrenctVsPastGraph,
    "Gross Net Revenue": RevGrossNetGraph,
    "Gross Net Margin": GrossNetMarginGraph,
    "Gross Net Profit Growth": GrossNetProfitGrowthGraph,
    "Gross & Net Profits: Past And Present": GrossNetPastAndPresentGraph,
    "EPS Qtr On Qtr": EPSQtrOnQtrGraph,
    "EPS Growth Qtr On Qtr Trend Line": EPSGrowthQtrOnQtrTrendLineGraph,
    "Revenue Qtr On Qtr": RevenueQtrOnQtrGraph,
    "Revenue Growth Qtr On Qtr Trend Line": RevenueGrowthQtrOnQtrTrendLineGraph,
    "Gross Profit Qtr On Qtr": GrossProfitQtrOnQtrGraph,
    "Gross Profit Growth Qtr On Qtr Trend Line":
      GrossProfitGrowthQtrOnQtrTrendLineGraph,
    "Net Profit Qtr On Qtr": NetProfitQtrOnQtrGraph,
    "Net Profit Growth Qtr On Qtr Trend Line":
      NetProfitGrowthQtrOnQtrTrendLineGraph,
    "TTM Revenue Comparison": TTMRevenueGraph,
  };

  useEffect(() => {
    if (
      !graphCategoriesLoading &&
      graphCategories &&
      ((compareResults && Object.keys(compareResults).length) ||
        (compareOtherStockResults &&
          Object.keys(compareOtherStockResults).length))
    ) {
      setSelectedStock([
        ...(primaryStock && Object.keys(primaryStock).length
          ? [primaryStock]
          : []),
      ]);
      setSelectedSecondaryStocks([...stocksToCompare?.map((m: any) => m)]);
      setTabStockComapre(stocksToCompare);
      setGraphCategories(graphCategories);
      let tabs = graphCategories
        .filter((category: any) => {
          if (
            stocksToCompare &&
            stocksToCompare.length == 0 &&
            "Comparable Stocks" === category.name
          )
            return false;
          if (
            !["Profitability", "Company Profile"].includes(category.name) &&
            !isAllowed([KEYS.DYNAMIC_GRAPHS], allowed)
          )
            return false;
          return category;
        })
        .map((category: any) => {
          if (category.name === "Company Profile") {
            return {
              label: category.name,
              content: (
                <CompanyProfiles
                  selectedStocks={[
                    ...(primaryStock && Object.keys(primaryStock).length
                      ? [primaryStock.id]
                      : []),
                    ...stocksToCompare.map((m: any) => m.id),
                  ]}
                />
              ),
            };
          }

          return {
            label: category.name,
            content: (
              <DynamicTab
                name={category.name}
                snapshots={category.snapshots}
                primaryStock={
                  primaryStock && Object.keys(primaryStock).length
                    ? [primaryStock]
                    : []
                }
                selectedStocks={stocksToCompare}
                staticGraphs={staticGraphs}
                compareResults={compareResults}
                compareOtherStockResults={compareOtherStockResults}
              />
            ),
          };
        });

      setT(tabs);
    }
  }, [
    graphCategories,
    graphCategoriesLoading,
    stocksToCompare,
    compareResults,
    compareOtherStockResults,
  ]);

  return (
    <div className="vi-cmp flex lg:flex-row flex-col items-center md:items-start w-full select-none">
      <div
        className={`flex flex-col w-full ${
          isPremiumUser || !showAdPanel ? "lg:!w-full" : "lg:!w-9/12"
        } border-r  overflow-y-auto  items-start px-4 py-3 `}
      >
        <div className="w-full flex items-start justify-between gap-4">
          <TitleArea
            variant="page"
            title="Compare"
            subTitle="Compare and visualize trends and performance across multiple stocks."
          />
          <DisclaimerButton />
        </div>

        <div className=" w-full border border-[#D0D5DD]  my-2" />
        <StockSelector
          onHandleGenerate={handleGenerate}
          stocks={!stocks?.length ? [] : stocks}
          epsGrowth={epsGrowth || ""}
          peEstimatea={peEstimatea || ""}
          primaryStock={primaryStocks}
          secondaryStocks={secondaryStocks}
          setPrimaryStock={setPrimaryStocks}
          setSecondaryStocks={setSecondaryStocks}
          setScrollDirection={setScrollDirection}
          loading={stockLoading}
          scrollUpdate={scrollUpdate}
          setScrollUpdate={setScrollUpdate}
          mobileScrollIndex={mobileScrollIndex}
          setMobileScrollIndex={setMobileScrollIndex}
          isMobile={isMobile}
        />
        <div className=" w-full border border-[#D0D5DD]  my-2" />
        <MoreOptions
          setEpsGrowth={setEpsGrowth}
          setPeEstimate={setPeEstimates}
          primaryStock={primaryStocks}
          secondaryStocks={secondaryStocks}
          epsGrowth={epsGrowth || ""}
          peEstimatea={peEstimatea || ""}
          handleGEnerate={handleGenerate}
        />
        <div className=" w-full border border-[#D0D5DD]  my-2" />
        <Tabs
          defaultActiveKey="parameters"
          className="w-full vi-cmp-section-tabs"
          items={[
            {
              key: "parameters",
              label: "Parameters",
              children: (
                <div className="flex gap-x-4 max-w-full overflow-x-auto !scrollbar-hide ">
                  <StockComparisonTable
                    primaryData={primaryStock ? compareResults : []}
                    compareOtherStockResults={compareOtherStockResults}
                    compareLoading={compareLoading}
                    peEstimate={peEstimate}
                    primaryStock={primaryStock}
                    scrollDirection={scrollDirection}
                    scrollUpdate={scrollUpdate}
                    selectedStocks={secondaryStocks}
                    mobileScrollIndex={mobileScrollIndex}
                    isMobile={isMobile}
                  />
                </div>
              ),
            },
            {
              key: "primary-stock-details",
              label: "Primary Stock Details",
              children: (
                <PrimaryInsights
                  primaryStock={selectedStock}
                  categories={grapCategories}
                  selectedStocks={selectedSecondaryStocks}
                  KEYS={KEYS}
                  isAllowed={isAllowed}
                  allowed={allowed}
                  staticGraphs={staticGraphs}
                  compareResults={compareResults}
                  compareOtherStockResults={compareOtherStockResults}
                  stocksToCompare={tabStockComapre}
                  compareLoading={
                    primaryStock && !compareLoading
                      ? stockLoading
                      : compareLoading
                  }
                  hasData={primaryStocks !== null}
                  onCurrencyDetected={(currency: string) =>
                    setPrimaryCurrency(currency)
                  }
                />
              ),
            },
            {
              key: "comparative-insights",
              label: "Comparative Insights",
              children: (
                <ComparativeInsights
                  primaryStock={selectedStock}
                  categories={grapCategories}
                  selectedStocks={selectedSecondaryStocks}
                  KEYS={KEYS}
                  isAllowed={isAllowed}
                  allowed={allowed}
                  staticGraphs={staticGraphs}
                  compareResults={compareResults}
                  compareOtherStockResults={compareOtherStockResults}
                  stocksToCompare={tabStockComapre}
                  compareLoading={
                    secondaryStocks && !compareLoading
                      ? stockLoading
                      : compareLoading
                  }
                />
              ),
            },
          ]}
        />
        <div className=" w-full border border-[#D0D5DD]  my-2" />
      </div>

      {/* Ad column — the actual ad-fetching/rendering markup below stays
          commented out (unrelated to this pass, see task history); this
          wrapper just gives that reserved w-3/12 space a collapse/
          expand arrow instead of always being blank dead space. Hidden
          entirely for premium users, same as before. No breakpoint-based
          `hidden` here (unlike an earlier version of this change) — the
          original markup this replaces was visible at every width (full-
          width, stacked below the main column, on narrower screens), and
          gating the whole block behind `lg:` hid the arrow itself below
          1024px instead of just changing its layout. */}
      {!isPremiumUser && (
        <div
          className={`relative self-stretch flex flex-col shrink-0 transition-all duration-300 ${
            showAdPanel ? "w-full lg:w-3/12" : "w-0"
          }`}
        >
          {/* self-stretch above overrides the row's own items-start (main
              content and this column otherwise only take their natural
              content height) so this column's height actually matches
              the row — needed for the button below to center against the
              full height of the divider line rather than sitting near
              the top, where this column's own (collapsed, near-empty)
              content used to end. */}
          <button
            onClick={() => setShowAdPanel((prev) => !prev)}
            aria-label={showAdPanel ? "Hide advertisement" : "Show advertisement"}
            title={showAdPanel ? "Hide advertisement" : "Show advertisement"}
            className="vi-glass-button absolute top-1/2 -translate-y-1/2 -left-4 z-10 flex items-center justify-center w-7 h-7 rounded-full flex-shrink-0"
          >
            {showAdPanel ? (
              <ChevronRight size={16} />
            ) : (
              <ChevronLeft size={16} />
            )}
          </button>

          {showAdPanel && (
            <div className="flex flex-col gap-8 mx-2 items-center relative px-2 py-4 w-full h-full overflow-hidden">
              {/* {adverts && adverts?.length ? (
                <>
                  {adverts
                    ?.filter((ad: any) => ad?.section === "fundamental-analysis")
                    ?.map((ad: any) => (
                      <img
                        className=" h-fit object-cover"
                        src={`data:${ad?.type};base64,${ad?.image}`}
                        alt={`ad no ${ad?.id}`}
                      />
                    ))}

                  <Entitlement allowedKeys={["ADD_ADS"]}>
                    <AdBanner
                    handleOnClick={() => {
                      toggleAdModal(!adModal);
                    }}
                    />
                  </Entitlement>
                </>
              ) : null} */}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CompareDashboard;
